<script lang="ts">
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { Vue, Component } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { lexnetTokenApi } from '@/services/AuthService'
import { LexnetEscritoId } from '@/components/Lexnet/types/LexnetTypes'

const authModule = ModuleNamespaces.AUTH

@Component
export default class LexnetMixin extends Vue {
  @Getter('getUserId', { namespace: authModule }) idUser: number
  @Getter('getCompanyId', { namespace: authModule }) idCompany: number

  token: string = ''
  refreshToken: string = ''

  async openInLexnet(selectedRegister: any) {
    await this.getLexNetToken()
    this.openEditLexnetApp(selectedRegister.idLexnet, false)
  }

  openLexnetApp(sameWindow: boolean = true) {
    const url = `${process.env.VUE_APP_LEXNET_URL}${this.token}&refreshToken=${this.refreshToken}`
    if (sameWindow) {
      window.location.replace(url)
    } else {
      window.open(url, '_blank')
    }
  }

  openNewEscritoLexnetApp(
    escritoType: number,
    docId: number,
    entityId: number,
    entityTypeId: number,
    companyId: number
  ) {
    const url = `${process.env.VUE_APP_LEXNET_NEW_ESCRITO_URL}${this.token}&idTipoEscrito=${escritoType}&idDocument=${docId}&idEntity=${entityId}&idEntityType=${entityTypeId}&idCompany=${companyId}&refreshToken=${this.refreshToken}`
    window.open(url, '_blank')
  }

  openEditLexnetApp(idLexnet: number, sameWindow: boolean = true) {
    const url = `${process.env.VUE_APP_LEXNET_EDIT_URL}${idLexnet}/?token=${this.token}&refreshToken=${this.refreshToken}`
    if (sameWindow) {
      window.location.replace(url)
    } else {
      window.open(url, '_blank')
    }
  }

  async getLexNetToken() {
    const { data } = await lexnetTokenApi(this.idUser, this.idCompany)

    if (data && data.accessToken) {
      this.token = data.accessToken
      this.refreshToken = data.refreshToken
    }
  }

  getLexnetIdFromName(typeName: string) {
    return LexnetEscritoId[(typeName as any).toUpperCase()]
  }
}
</script>
